import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import * as d3 from 'd3';
import { useEffect, useRef, memo } from 'react';
import { useChartData } from '../context/ChartContext';
import useSpectrum from '../hooks/useSpectrum';
import { get2DYScale } from './utilities/scale';
const axisStyles = css `
  user-select: none;

  path,
  line {
    fill: none;
    stroke: black;
    stroke-width: 1;
    shape-rendering: crispedges;
    user-select: none;
  }
`;
const defaultMargin = { right: 50, top: 0, bottom: 0, left: 0 };
function YAxis(props) {
    const { show = true, label = '', margin: marginProps = defaultMargin, } = props;
    const refAxis = useRef(null);
    const { yDomain, width, height, margin } = useChartData();
    const spectrum = useSpectrum();
    useEffect(() => {
        if (!show || !yDomain)
            return;
        const scaleY = get2DYScale({ height, yDomain, margin }, !!spectrum?.info?.isFid);
        const axis = d3.axisRight(scaleY).ticks(8).tickFormat(d3.format('0'));
        // @ts-expect-error well typed
        d3.select(refAxis.current).call(axis);
    }, [spectrum, height, yDomain, margin, show]);
    if (!width || !height) {
        return null;
    }
    return (_jsx("g", { className: "y", css: axisStyles, transform: `translate(${width - marginProps.right})`, ref: refAxis, children: _jsx("text", { fill: "#000", x: -marginProps.top, y: -(marginProps.right - 5), dy: "0.71em", transform: "rotate(-90)", textAnchor: "end", children: label }) }));
}
export default memo(YAxis);
